export default class SearchFilterOption{

	constructor(ID, value, pPosition) {
		this.ID = ID;
		this.value = value;
		this.position = pPosition;
		this.active = false;
	}
}
